import React from 'react';
import { Separator } from './ui/separator';
import { Phone, Mail, MapPin } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Services',
      links: [
        { text: 'DPE', href: '/#services' },
        { text: 'Diagnostic Amiante', href: '/#services' },
        { text: 'Diagnostic Plomb', href: '/#services' },
        { text: 'Diagnostic Termites', href: '/#services' },
        { text: 'Gaz & Électricité', href: '/#services' },
        { text: 'Loi Carrez / Boutin', href: '/#services' }
      ]
    },
    {
      title: 'Informations',
      links: [
        { text: 'Tarifs', href: '/#contact' },
        { text: 'Zone d\'intervention', href: '/#zone' },
        { text: 'Certifications', href: '/#about' },
        { text: 'Mentions légales', href: '/cgv' },
        { text: 'CGV', href: '/cgv' }
      ]
    }
  ];

  return (
    <footer className="bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900 text-stone-100">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src="/logo.jpeg" 
                alt="MonDiagImmo" 
                className="w-12 h-12 rounded-full shadow-lg" 
              />
              <span className="text-2xl font-bold text-white whitespace-nowrap">
                MonDiagImmo
              </span>
            </div>
            <p className="text-stone-400 leading-relaxed">
              Diagnostiqueuse immobilière certifiée à Marseille. Professionnalisme, expertise et accompagnement personnalisé.
            </p>
          </div>

          {/* Links */}
          {footerLinks.map((section, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-lg font-bold text-white">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.href} 
                      className="text-stone-400 hover:text-emerald-400 transition-colors duration-200 inline-block hover:translate-x-1 transform"
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-white">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-stone-400">{mockData.contact.phone}</span>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-stone-400">{mockData.contact.email}</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-stone-400">{mockData.contact.address}</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-stone-700" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-stone-400 text-sm">
          <p>© {currentYear} MonDiagImmo. Tous droits réservés.</p>
          <p>
            N°SIREN : 921774774 | Compagnie d'assurance : LCL n° 3991090904
          </p>
        </div>
      </div>
    </footer>
  );
};